import Button from 'components/Basic/Button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { setEnableMergeFacets } from 'store/slices/RoofEditSlice';

const ACTIVE_BTN_STYLE = {
	background: 'var(--primary)',
	color: 'var(--btnLabel)',
	borderColor: 'var(--primary)',
};

export default function MergeFacetsStrip() {
	const { enableMergeFacets } = useSelector((state: RootState) => state.roofEditData.data);
	const dispatch = useDispatch();

	return (
		<Button
			id="merge-facets"
			className={`${enableMergeFacets ? 'active ' : ''}auto-detection-btn`}
			style={enableMergeFacets ? ACTIVE_BTN_STYLE : undefined}
			onClick={() => dispatch(setEnableMergeFacets({ isEnable: !enableMergeFacets }))}
		>
			Merge facets
		</Button>
	);
}
